import styled from '@emotion/styled';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import colors from 'config/theme/colors';
import { clearDealersModalFilter, removeDealersModalFilter } from 'modules/dealers/actions';

import { isUnfoldedSearch, getFormattedFilters } from 'modules/dealers/selectors/modalSelect';

import AdvancedSearch from './AdvancedSearch';
import BaseFilterHeader from '../../FiltersHeader/index';

/** @type {BaseFilterHeader} */
const FilterHeader = styled(BaseFilterHeader)`
  padding: 16px 24px;
  background-color: ${colors['@body-bg']};
  border-bottom: none;

  span[class*='-Title'] {
    font-size: 14px;
    font-weight: bold;
  }

  > .ant-col:last-child {
    span[class*='-Label'] {
      font-size: 14px;
      font-weight: normal;
      color: ${colors['@font-grey-light']};
    }

    .ant-tag {
      font-size: 14px;
      padding: 2px 4px;
      border: solid 1px ${colors['@btn-default-border']};
      background-color: transparent;
      color: #1d252d;

      > .anticon {
        color: ${colors['@btn-default-border']};
      }
    }
  }
`;

const SearchPanel = () => {
  const dispatch = useDispatch();
  const isUnfold = useSelector(isUnfoldedSearch);
  const filters = useSelector(getFormattedFilters);

  /**
   * @param {string} filterId
   * @param {any} valueToRemove
   */
  const handleOnDelete = (filterId, valueToRemove) => {
    dispatch(removeDealersModalFilter(filterId, valueToRemove));
  };

  const handleClearFiltersOnClick = () => {
    dispatch(clearDealersModalFilter());
  };

  return (
    <React.Fragment>
      {!isUnfold && (
        <FilterHeader
          onDelete={handleOnDelete}
          filters={filters}
          clearFilters={handleClearFiltersOnClick}
          className="hide-mobile"
        />
      )}
      {isUnfold && <AdvancedSearch />}
    </React.Fragment>
  );
};

export default SearchPanel;
